export const typeInvoice = [
  { id: "invoice", name: "Adhoc/Invoice" },
  { id: "credit_note", name: "Credit Note" },
];

export const statusList = [
  { id: "active", name: "Active" },
  { id: "inactive", name: "Inactive" },
];
